import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { setupNativeShell } from './lib/native-shell';
import { setupAnalytics } from './lib/analytics';
import './style.css';

createApp(App).use(createPinia()).use(router).mount('#app');
void setupNativeShell(router);
setupAnalytics(router);
